export default "__VITE_ASSET__BJd9qtnL__"